export class RecyclerBac {
  constructor(
    technicalId,
    boomerangId,
    designation,
    pictureName,
    pictureUrl,
    pictureQrCodeName,
    pictureQrCodeUrl,
    fillingThreshold,
    recyclerName,
    recyclerLogoName,
    recyclerLogoUrl
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.designation = designation
    this.pictureName = pictureName
    this.pictureUrl = pictureUrl
    this.pictureQrCodeName = pictureQrCodeName
    this.pictureQrCodeUrl = pictureQrCodeUrl
    this.fillingThreshold = fillingThreshold
    this.recyclerName = recyclerName
    this.recyclerLogoName = recyclerLogoName
    this.recyclerLogoUrl = recyclerLogoUrl
  }
}
